import { Flex } from '../Container/Flex';
import { Bold } from '../../utils/style/texts';
import React from 'react';
import styled from 'styled-components';

const AccordionHeader = ({ icon: Icon, text, className, headerStyle }) => (
  <Flex align="center" className={className}>
    {Icon ? <Icon color="action" /> : null}
    <Header style={headerStyle}>{text}</Header>
  </Flex>
);

export default AccordionHeader;

const Header = styled(Bold)`
  margin-left: 10px;
`;